/* Kanadeal — injecte la section Fidelite (carte de points) sur la page d'accueil,
   JUSTE AU-DESSUS de la section FAQ. Connecte: prenom + solde reels. Deconnecte:
   carte d'EXEMPLE clairement identifiee + invitation a creer un compte.
   La carte entiere est cliquable -> /pages/mes-points.
   + Effet 3D pilote au SCROLL (tilt) et balayage de lumiere sur la carte. */
(function () {
  if (window.__kdHomeFideliteInit) return;
  window.__kdHomeFideliteInit = true;

  var POINTS_URL = '/pages/mes-points';
  var DEMO_PTS = 1240; // exemple illustratif quand non connecte

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function levelFor(p) { return p >= 1500 ? 'OR' : (p >= 500 ? 'ARGENT' : 'BRONZE'); }

  function buildHTML() {
    var M = window.KD_MEMBER || {};
    var inn = !!M.loggedIn;
    var rawName = (M.firstName && String(M.firstName).trim() && String(M.firstName).trim() !== 'John Doe') ? String(M.firstName).trim() : '';
    var pts = inn ? ((typeof M.points === 'number' && isFinite(M.points)) ? M.points : 0) : DEMO_PTS;
    var ptsStr; try { ptsStr = pts.toLocaleString('fr-FR'); } catch (e) { ptsStr = String(pts); }
    var level = levelFor(pts);

    var memberLine = inn
      ? '<span class="kdf__member">MEMBRE · ' + esc(rawName || 'Membre') + '</span><span class="kdf__level">NIVEAU ' + level + '</span>'
      : '<span class="kdf__member">CARTE EXEMPLE</span><span class="kdf__level">NIVEAU ' + level + '</span>';

    var demoTag = inn ? '' : '<span class="kdf__demo">Exemple</span>';
    var note = inn ? '' :
      '<p class="kdf__note">🔓 Pas encore de points ? <b>Crée ton compte</b> et passe une commande pour commencer à cumuler — <b>1 € = 1 point</b>. La carte ci-contre est un exemple.</p>';
    var ctaHref = inn ? POINTS_URL : '/account/register';
    var ctaText = inn ? 'Voir mes points ⚡' : 'Créer mon compte ⚡';

    return '' +
      '<div class="kdf__inner">' +
        '<div class="kdf__content">' +
          '<span class="kdf__badge">⚡ Programme de fidélité</span>' +
          '<h2 class="kdf__title">Tes commandes te récompensent</h2>' +
          '<p class="kdf__text">Cumule des points à chaque achat et transforme-les en réductions. Côté Club Kanadeal : livraison offerte, nouveautés en avant-première et parrainage qui rapporte.</p>' +
          note +
          '<ul class="kdf__pills">' +
            '<li class="kdf__pill"><span class="kdf__pill-dot">⭐</span>Paliers VIP</li>' +
            '<li class="kdf__pill"><span class="kdf__pill-dot">⭐</span>Nouveautés en avant-première</li>' +
            '<li class="kdf__pill"><span class="kdf__pill-dot">⭐</span>Parrainage récompensé</li>' +
          '</ul>' +
          '<a href="' + ctaHref + '" class="kdf__cta">' + ctaText + '</a>' +
        '</div>' +
        '<a class="kdf__card-wrap" href="' + POINTS_URL + '" aria-label="Voir mes points">' +
          '<div class="kdf__card' + (inn ? '' : ' kdf__card--demo') + '">' +
            '<span class="kdf__glare" aria-hidden="true"></span>' +
            demoTag +
            '<span class="kdf__free">GRATUIT</span>' +
            '<div class="kdf__brand">KANADEAL</div>' +
            '<div class="kdf__chip"></div>' +
            '<div class="kdf__pts-label">' + (inn ? 'SOLDE DE POINTS' : 'EXEMPLE DE SOLDE') + '</div>' +
            '<div class="kdf__pts">' + esc(ptsStr) + ' pts</div>' +
            '<div class="kdf__row">' + memberLine + '</div>' +
          '</div>' +
        '</a>' +
      '</div>';
  }

  function findFaqSection(main) {
    var secs = main.querySelectorAll('.shopify-section');
    for (var i = 0; i < secs.length; i++) {
      if (secs[i].querySelector('.accordion')) return secs[i];
    }
    return null;
  }

  function inject() {
    var main = document.querySelector('main[data-template="index"]');
    if (!main) return;
    var sec = main.querySelector('.kd-home-fidelite');
    if (!sec) {
      sec = document.createElement('section');
      sec.className = 'kd-home-fidelite';
      sec.innerHTML = buildHTML();
    }
    var faq = findFaqSection(main);
    if (faq) {
      if (sec.parentNode !== main || sec.nextElementSibling !== faq) {
        main.insertBefore(sec, faq);
      }
    } else if (!sec.parentNode) {
      main.appendChild(sec);
    }
    setupTilt();
  }

  function setupTilt() {
    if (window.__kdFideliteTilt) return;
    var card = document.querySelector('.kd-home-fidelite .kdf__card');
    if (!card) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.__kdFideliteTilt = true;
    var ticking = false;
    function update() {
      ticking = false;
      var r = card.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.bottom < -120 || r.top > vh + 120) return;
      var center = r.top + r.height / 2;
      var p = (center - vh / 2) / (vh / 2 + r.height / 2);
      if (p > 1) p = 1; else if (p < -1) p = -1;
      var isM = window.innerWidth <= 749;
      var ax = isM ? 9 : 13;
      var ay = isM ? 7 : 9;
      var baseRy = isM ? -10 : -15;
      var ty = isM ? 7 : 12;
      card.style.setProperty('--kd-rx', (5 - p * ax).toFixed(2) + 'deg');
      card.style.setProperty('--kd-ry', (baseRy + p * ay).toFixed(2) + 'deg');
      card.style.setProperty('--kd-rz', (-p * 2).toFixed(2) + 'deg');
      card.style.setProperty('--kd-ty', (-p * ty).toFixed(1) + 'px');
      card.style.setProperty('--kd-gx', ((p * 0.5 + 0.5) * 130 - 65).toFixed(1) + '%');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() { inject(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  [200, 600, 1200, 2000, 3000].forEach(function (d) { setTimeout(inject, d); });
})();
